import {useQuery} from "@tanstack/react-query";

import {getCsrfTokenQueryOptions} from "./get-csrf-token.query-options";

export function useGetCsrfToken(enabled = true) {
  return useQuery({
    ...getCsrfTokenQueryOptions(),
    enabled,
  });
}
